import React from 'react';
import { PricingCard } from './PricingCard';
import { UrgencyBlock } from './UrgencyBlock';
export function FinalCTA() {
  return <section className="bg-deep py-14" data-id="element-61" data-mp="3udozur6inmq0">
      <div className="mx-auto max-w-page px-5" data-id="element-62" data-mp="3ueqawvnj897q">
        <h2 className="text-center font-display text-[28px] font-black leading-tight text-canvas sm:text-[36px]" data-id="element-63" data-mp="c7tzjwqv7ezu">
          Última llamada al{' '}
          <span className="italic text-amber" data-id="element-64" data-mp="87jow6s4o0en">precio de lanzamiento</span>
        </h2>
        <p className="mx-auto mt-3 max-w-md text-center text-[14.5px] leading-relaxed text-canvas/70" data-id="element-65" data-mp="m2vjme6a9qvk">
          Cuando termine el contador, el Protocolo vuelve a su valor de $67.900 y los 3 bonos dejan de
          estar incluidos.
        </p>

        <div className="mt-7" data-id="element-66" data-mp="qvexzdcsoq1f">
          <UrgencyBlock tone="dark" data-id="element-67" data-mp="qw6ucqe7ursr" />
        </div>

        <div className="mt-5" data-id="element-68" data-mp="14v6h1si64wma">
          <PricingCard showBreakdown={false} data-id="element-69" data-mp="14w7we967w59t" />
        </div>
      </div>
    </section>;
}